module.exports = __webpack_public_path__ + "static/banner-b1e23e5f51c3ca4d09c800280a2bf8b4.png";